module.exports = flarum.core.compat['components/TerminalPost'];